import { render, staticRenderFns } from "./RoomCategoryDetail.vue?vue&type=template&id=4665635c&scoped=true"
import script from "./RoomCategoryDetail.vue?vue&type=script&lang=js"
export * from "./RoomCategoryDetail.vue?vue&type=script&lang=js"
import style0 from "./RoomCategoryDetail.vue?vue&type=style&index=0&id=4665635c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4665635c",
  null
  
)

export default component.exports